import updateItemRequest from 'owa-service/lib/factory/updateItemRequest';
import UpdateItemResponse from 'owa-service/lib/contract/UpdateItemResponse';
import Message from 'owa-service/lib/contract/Message';
import { getJsonRequestHeader } from 'owa-service/lib/ServiceRequestUtils';
import updateItemOperation from 'owa-service/lib/operation/updateItemOperation';
import itemId from 'owa-service/lib/factory/itemId';
import itemChange from 'owa-service/lib/factory/itemChange';

function createRequestBody(messageType: Message) {
    if (!messageType.ItemId) {
        throw new Error('No ItemID on message');
    }

    let itemChanges = itemChange({
        Updates: [],
        ItemId: itemId({
            Id: messageType.ItemId.Id,
            ChangeKey: messageType.ItemId.ChangeKey,
        }),
    });

    return updateItemRequest({
        ItemChanges: [itemChanges],
        ConflictResolution: 'AlwaysOverwrite',
        ClientSupportsIrm: false,
        SendCalendarInvitationsOrCancellations: 'SendToNone',
        MessageDisposition: 'SendAndSaveCopy',
        SuppressReadReceipts: false,
        ComposeOperation: 'newMail',
        OutboundCharset: 'AutoDetect',
        PromoteEmojiContentToInlineAttachmentsCount: 0,
        UnpromotedInlineImageCount: 0,
        PromoteInlineAttachments: false,
        SendOnNotFoundError: true,
    });
}

export default function updateAndSendMessage(message: Message): Promise<UpdateItemResponse> {
    let requestBody = createRequestBody(message);

    return updateItemOperation({
        Header: getJsonRequestHeader(),
        Body: requestBody,
    }).then(response => {
        return response.Body;
    });
}
